/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Products.css";

function Gallery() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  const totalItems = 8;
  const duplicatedItems = 3;

  const [isContactOpen, setIsContactOpen] = useState(false);

  const toggleOpen = () => {
    setIsContactOpen(!isContactOpen);
  };

  return (
    <div>
      {/* Left-scrolling section */}
      <section className="gallery-container left-scroll">
        <a
          href={`https://order.elyx.work/?lang=${currentLang}`}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
          onClick={toggleOpen}
        >
          <div className="gallery">
            <div className="gallery-items left-scroll">
              {Array.from(
                { length: totalItems * duplicatedItems },
                (_, index) => (index % totalItems) + 1,
              ).map((item, index) => (
                <div className="gallery-item" key={`${item}-${index}`}>
                  <img
                    src={`/website/website${item}.web`}
                    alt={`Website ${item}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </a>

        <a
          href={`https://htmltagss.com/?lang=${currentLang}`}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
        >
          <div className="gallery-2">
            <div className="gallery-items-2 right-scroll">
              {Array.from(
                { length: totalItems * duplicatedItems },
                (_, index) => (index % totalItems) + 1,
              ).map((item, index) => (
                <div className="gallery-item-2" key={`${item}-${index}`}>
                  <img
                    src={`/website2/website${item}.web`}
                    alt={`Website ${item}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </a>

        <a
          href={`https://htmltagss.com/ColorGenerator?lang=${currentLang}`}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
        >
          <div className="gallery-3">
            <div className="gallery-items-3 left-scroll">
              {Array.from(
                { length: totalItems * duplicatedItems },
                (_, index) => (index % totalItems) + 1,
              ).map((item, index) => (
                <div className="gallery-item-3" key={`${item}-${index}`}>
                  <img
                    src={`/website3/website${item}.web`}
                    alt={`Website ${item}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </a>
      </section>
    </div>
  );
}

export default Gallery;
